import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import NagusiBackNav from '../common/NagusiBackNav';
export default class LeagueStandingsPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "seasonParam", '');
    _defineProperty(this, "teamParam", 'athletic-club');
    _defineProperty(this, "loading", true);
    _defineProperty(this, "standings", []);
    _defineProperty(this, "seasons", []);
    _defineProperty(this, "selectedSeason", null);
    _defineProperty(this, "updatedAt", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    const routeSeason = m.route.param('season');
    this.seasonParam = routeSeason ? routeSeason.replace(/\//g, '-') : '2026-2027';
    this.teamParam = m.route.param('team') || 'athletic-club';
    this.loadData();
  }
  onupdate(vnode) {
    if (super.onupdate) {
      super.onupdate(vnode);
    }
    const routeSeason = m.route.param('season');
    const routeTeam = m.route.param('team') || 'athletic-club';
    if (routeSeason) {
      const normalized = routeSeason.replace(/\//g, '-');
      if (normalized !== this.seasonParam || routeTeam !== this.teamParam) {
        this.seasonParam = normalized;
        this.teamParam = routeTeam;
        this.loadData();
      }
    }
  }
  loadData() {
    this.loading = true;
    const pSeasons = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/seasons'
    });
    const pStandings = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/league-standings',
      params: {
        season: this.seasonParam
      }
    });
    Promise.all([pSeasons, pStandings]).then(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        seasonsResp = _ref2[0],
        standingsResp = _ref2[1];
      const MIN_STANDINGS_SEASON = '2025-2026';
      const seasons = app.store.pushPayload(seasonsResp) || [];
      this.seasons = seasons.filter(s => s.name().replace(/\//g, '-') >= MIN_STANDINGS_SEASON).sort((a, b) => b.name().localeCompare(a.name()));
      const normalizedParam = (this.seasonParam || '').replace(/\//g, '-');
      this.selectedSeason = this.seasons.find(s => s.name().replace(/\//g, '-') === normalizedParam) || this.seasons[0];
      if (this.selectedSeason) {
        this.seasonParam = this.selectedSeason.name().replace(/\//g, '-');
      }
      this.standings = standingsResp.standings || [];
      this.updatedAt = standingsResp.updated_at ? new Date(standingsResp.updated_at).toLocaleString() : null;
      this.loading = false;
      m.redraw();
    }).catch(err => {
      console.error(err);
      this.loading = false;
      m.redraw();
    });
  }
  onSeasonChange(e) {
    const target = e.target;
    const newSeason = target.value;
    this.seasonParam = newSeason;
    m.route.set("/clasificacion/".concat(newSeason, "/").concat(this.teamParam));
    this.loadData();
  }
  view() {
    const seasonName = this.selectedSeason ? this.selectedSeason.name() : this.seasonParam.replace('-', '/');
    return m("div", {
      className: "LeagueStandingsPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 30px; padding-bottom: 50px;"
    }, m(NagusiBackNav, {
      title: "Clasificaci\xF3n de LaLiga"
    }), m("div", {
      className: "LeagueStandingsPage-header",
      style: "display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 20px; margin-bottom: 35px; border-bottom: 2px solid rgba(255,255,255,0.08); padding-bottom: 20px;"
    }, m("div", null, m("h1", {
      style: "font-size: 2.4em; font-weight: 900; margin: 0; color: var(--heading-color); letter-spacing: -0.02em;"
    }, m("i", {
      className: "fas fa-list-ol",
      style: "margin-right: 12px; color: #ee2523;"
    }), "Clasificaci\xF3n de LaLiga"), m("p", {
      style: "margin: 6px 0 0 0; color: var(--muted-color); font-size: 1.1em;"
    }, "Athletic Club \u2014 Temporada ", seasonName)), m("div", {
      style: "display: flex; align-items: center; gap: 12px; flex-wrap: wrap;"
    }, m("a", {
      href: "/calendario/".concat(this.seasonParam, "/").concat(this.teamParam),
      className: "Button Button--secondary",
      style: "border-radius: 10px; padding: 8px 16px; font-weight: bold; display: inline-flex; align-items: center; gap: 8px; text-decoration: none; height: 42px; border: 1px solid rgba(255,255,255,0.2);"
    }, m("i", {
      className: "far fa-calendar-alt",
      style: "color: #ee2524;"
    }), m("span", null, "Ver Calendario")), this.seasons.length > 0 && m("div", {
      style: "display: flex; align-items: center; gap: 10px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.95em;"
    }, "Temporada"), m("select", {
      className: "FormControl",
      value: this.seasonParam,
      onchange: e => this.onSeasonChange(e),
      style: "border-radius: 10px; padding: 8px 16px; font-weight: bold; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.15); height: 42px; cursor: pointer;"
    }, this.seasons.map(s => {
      const slug = s.name().replace('/', '-');
      return m("option", {
        value: slug
      }, s.name());
    }))))), this.loading ? m("div", {
      style: "text-align: center; padding: 60px 0;"
    }, m(LoadingIndicator, null)) : m("div", {
      className: "LeagueStandingsPage-card",
      style: "background: var(--body-bg, #ffffff); border-radius: 16px; border: 1px solid var(--control-bg, rgba(0,0,0,0.1)); overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.06);"
    }, m("div", {
      style: "padding: 16px 20px; background: var(--control-bg, rgba(0,0,0,0.03)); border-bottom: 1px solid var(--control-bg, rgba(0,0,0,0.08)); display: flex; gap: 16px; flex-wrap: wrap; font-size: 0.85rem; align-items: center; color: var(--text-color);"
    }, m("div", {
      style: "display: flex; align-items: center; gap: 6px;"
    }, m("span", {
      style: "width: 10px; height: 10px; border-radius: 50%; background: #2563eb;"
    }), " Champions League"), m("div", {
      style: "display: flex; align-items: center; gap: 6px;"
    }, m("span", {
      style: "width: 10px; height: 10px; border-radius: 50%; background: #d97706;"
    }), " Europa League"), m("div", {
      style: "display: flex; align-items: center; gap: 6px;"
    }, m("span", {
      style: "width: 10px; height: 10px; border-radius: 50%; background: #059669;"
    }), " Conference League"), m("div", {
      style: "display: flex; align-items: center; gap: 6px;"
    }, m("span", {
      style: "width: 10px; height: 10px; border-radius: 50%; background: #dc2626;"
    }), " Descenso"), this.updatedAt && m("div", {
      style: "margin-left: auto; opacity: 0.7; font-size: 0.8rem; color: var(--muted-color);"
    }, "\xDAltima actualizaci\xF3n: ", this.updatedAt)), m("div", {
      style: "overflow-x: auto;"
    }, m("table", {
      style: "width: 100%; border-collapse: collapse; text-align: center; font-size: 0.95rem; color: var(--text-color);"
    }, m("thead", null, m("tr", {
      style: "background: var(--control-bg, rgba(0,0,0,0.02)); border-bottom: 2px solid var(--control-bg, rgba(0,0,0,0.08)); color: var(--muted-color); font-size: 0.82rem; text-transform: uppercase; letter-spacing: 0.05em;"
    }, m("th", {
      style: "padding: 12px 14px; text-align: center; width: 50px;"
    }, "Pos"), m("th", {
      style: "padding: 12px 16px; text-align: left;"
    }, "Equipo"), m("th", {
      style: "padding: 12px 10px; font-weight: 800; color: var(--heading-color);"
    }, "Ptos"), m("th", {
      style: "padding: 12px 10px;"
    }, "PJ"), m("th", {
      style: "padding: 12px 10px;"
    }, "G"), m("th", {
      style: "padding: 12px 10px;"
    }, "E"), m("th", {
      style: "padding: 12px 10px;"
    }, "P"), m("th", {
      style: "padding: 12px 10px;"
    }, "F"), m("th", {
      style: "padding: 12px 10px;"
    }, "C"), m("th", {
      style: "padding: 12px 10px;"
    }, "Dif"))), m("tbody", null, this.standings.map(row => {
      const isAthletic = row.team && (row.team.toLowerCase().includes('athletic') || row.team.toLowerCase().includes('bilbao'));

      // Zone indicator color
      let zoneColor = 'transparent';
      if (row.pos >= 1 && row.pos <= 4) zoneColor = '#2563eb';else if (row.pos === 5) zoneColor = '#d97706';else if (row.pos === 6) zoneColor = '#059669';else if (row.pos >= 18) zoneColor = '#dc2626';
      return m("tr", {
        style: {
          background: isAthletic ? 'rgba(238, 37, 36, 0.12)' : 'transparent',
          borderBottom: '1px solid var(--control-bg, rgba(0,0,0,0.06))',
          fontWeight: isAthletic ? 'bold' : 'normal',
          transition: 'background 0.2s ease'
        }
      }, m("td", {
        style: "padding: 12px 14px; position: relative;"
      }, m("div", {
        style: {
          position: 'absolute',
          left: '0',
          top: '0',
          bottom: '0',
          width: '4px',
          background: zoneColor
        }
      }), m("span", {
        style: {
          display: 'inline-block',
          width: '24px',
          height: '24px',
          lineHeight: '24px',
          borderRadius: '50%',
          background: isAthletic ? '#ee2524' : 'var(--control-bg, rgba(0,0,0,0.06))',
          color: isAthletic ? '#ffffff' : 'var(--text-color)',
          fontSize: '0.85rem',
          fontWeight: 'bold'
        }
      }, row.pos)), m("td", {
        style: "padding: 12px 16px; text-align: left;"
      }, m("div", {
        style: "display: flex; align-items: center; gap: 10px;"
      }, row.shield_url ? m("img", {
        src: row.shield_url,
        alt: row.team,
        style: "width: 24px; height: 24px; object-fit: contain;"
      }) : m("div", {
        style: "width: 24px; height: 24px; border-radius: 50%; background: var(--control-bg, rgba(0,0,0,0.1)); display: flex; align-items: center; justify-content: center; font-size: 0.7rem; font-weight: bold; color: var(--text-color);"
      }, row.team.substring(0, 2).toUpperCase()), m("span", {
        style: {
          color: isAthletic ? '#ee2524' : 'var(--heading-color)',
          fontWeight: isAthletic ? '800' : '500'
        }
      }, row.team))), m("td", {
        style: "padding: 12px 10px; font-weight: 800; font-size: 1.05rem; color: var(--heading-color);"
      }, row.pts), m("td", {
        style: "padding: 12px 10px; opacity: 0.9;"
      }, row.pj), m("td", {
        style: "padding: 12px 10px; color: #16a34a; font-weight: 600;"
      }, row.pg), m("td", {
        style: "padding: 12px 10px; color: #d97706; font-weight: 600;"
      }, row.pe), m("td", {
        style: "padding: 12px 10px; color: #dc2626; font-weight: 600;"
      }, row.pp), m("td", {
        style: "padding: 12px 10px; opacity: 0.9;"
      }, row.gf), m("td", {
        style: "padding: 12px 10px; opacity: 0.9;"
      }, row.gc), m("td", {
        style: {
          padding: '12px 10px',
          fontWeight: 'bold',
          color: row.dg > 0 ? '#16a34a' : row.dg < 0 ? '#dc2626' : 'var(--text-color)'
        }
      }, row.dg > 0 ? "+".concat(row.dg) : row.dg));
    })))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/gorbea/LeagueStandingsPage', LeagueStandingsPage);